// extracted by mini-css-extract-plugin
export default {"adminCommentsCard":"AdministrativeComments_adminCommentsCard__aQm-s","comment":"AdministrativeComments_comment__gxJlJ"};